export const toMinMediaQuery = (breakpoint) => {
    return `@media (min-width: ${breakpoint.minWidth})`;
};
export function toMediaQueryMap(breakpoints) {
    const mediaQueryMap = {};
    Object.keys(breakpoints).forEach((key) => {
        Object.assign(mediaQueryMap, { [key]: toMinMediaQuery(breakpoints[key]) });
    });
    return mediaQueryMap;
}
//# sourceMappingURL=mediaQueryHelper.js.map